export const ROUTES = {
  home: "/",
  list: "/list",
  view: "/view",
  wizard: "/wizard",
  login: "/login",
  register: "/register",
  rooms: "/room-ideas",
  // look: "/look",
  // lookActiveFeature: "/look/:partId",
  // lookActiveCategory: "/look/:partId/select",
  // quote: "/quote", // wtf? never used that
  lookId: ":lookId",
  lookFeatureSku: ":lookId/:skuId",
  // grohe
  category: "/category",
  // product journey
  print: "/print",
  cart: "/cart",
  cartLogin: "/cart/login",
  cartRegister: "/cart/register",
  cartTerms: "/cart/terms",
  cartBilling: "/cart/billing",
  cartBillingInfo: "/cart/billing/info",
  cartShipping: "/cart/shipping",
  cartPayment: "/cart/payment",
  cartDelivery: "/cart/delivery",
  cartTwoFAVerify: "/cart/twoFA/verify",
  cartTwoFA: "/cart/twoFA",
  cartConfirm: "/cart/confirm",
  cartSuccess: "/cart/success",
  shop: "/shop",
  shopRoutes: "/shop/:shopCategoryId/:skuId",
  sqft: "/sqft",
  sqftCabinetsIntro: "/sqft-cabinets-intro/:step",
  sqftCabinetsAR: "/sqft-cabinets-ar/:file", // this is for the models saved by Vlad's API (old not used)
  cabinetsAR: "/cabinets-ar/:file", // this is fr the urls created by exporting scene
  sqftCabinetsTutorial: "/sqft-cabinets-tutorial/:step",
  /// QKB routes
  quoting: "/quoting/:wizardId/:wizardStep",
  quoteDesign: "/quote-design",
  newscope: "/newscope",
  shoppingcart: "/shoppingcart",
  visualizer: "/visualizer",
  contract: "/sign",
};
